
export default {
  singleLabel: "Affaire",
  storeNamespace: 'business',
  authFeature: 'business',
  listRouteName: "BusinessList",
  newRouteName: "BusinessNew",
  editRouteName: "BusinessEdit",
  detailRouteName: "BusinessDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'BusinessForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  // false : les filtres secondaires (agence, responsable, code société) sont repliés
  // derrière « Plus d'options », le choix étant mémorisé par liste (store table_pref).
  showExtendedFilters: false,
  editCondition: item => item && item.is_import != 1,
  fields: [
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'number',
      label: "Code interne",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      // Code société SAP, alimenté par l'import OTP MyAxiloc : en lecture seule,
      // une saisie ici serait écrasée au prochain import.
      name: 'company_code',
      label: "Code société",
      type: 'text',
      inForm: false,
      inList: false,
      inDetail: true,
    },
    {
      // Donneur d'ordre (dernière colonne du fichier OTP), en lecture seule comme le code
      // société : il sort en « Code Client » dans l'export de facturation SAP.
      name: 'ordering_party',
      label: "Donneur d'ordre",
      type: 'text',
      inForm: false,
      inList: false,
      inDetail: true,
    },
    {
      // Entrée dédiée au filtre : le détail affiche un texte, le filtre propose la liste
      // des codes existants (cf. BusinessList, company_code_options). Deux rendus, deux
      // entrées — comme pour « Imputable » plus bas.
      name: 'company_code',
      label: "Code société",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      extendedFilter: true,
      // Après agence et responsable, qui restent les filtres de tête.
      filterOrder: 3,
    },
    {
      name: 'agency_internal_number',
      label: "Agence",
      type: 'chosen',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'agency',
      label: "Agence",
      type: 'select',
      inForm: false,
      inList: true,
      // Trier ~1,5 M affaires par agence imposerait de trier toute la jointure (> 3 s).
      sortable: false,
      filterIn: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.internal_number && value.name ? value.internal_number + " - " + value.name : null
    },
    {
      // Entrée dédiée au filtre : 644 agences, un <select> impose d'en dérouler la liste
      // entière. Même composant que le responsable, mais la recherche reste locale — les
      // agences tiennent dans le store, contrairement aux 46 000 fiches employé.
      name: 'agency',
      label: "Agence",
      type: 'autocomplete',
      filterComponent: 'AgencyAutocomplete',
      filterPlaceholder: "Code ou nom d'agence…",
      inForm: false,
      inList: false,
      inDetail: false,
      extendedFilter: true,
      filterOrder: 1,
    },
    {
      name: 'manager',
      label: "Responsable",
      // 'autocomplete' : le référentiel employé dépasse 46 000 fiches, un <select> chargerait
      // la liste entière. Le composant cherche côté serveur à la frappe.
      type: 'autocomplete',
      filterComponent: 'EmployeeAutocomplete',
      filterPlaceholder: "Nom, prénom ou matricule…",
      inForm: false,
      inList: true,
      sortable: false,
      filterIn: false,
      extendedFilter: true,
      filterOrder: 2,
      inDetail: true,
      detailLink: 'EmployeeDetail',
      inCsvExport: true,
      inPdfExport: true,
      // Le responsable vient du fichier OTP MyAxiloc. Les fiches créées à partir du seul
      // libellé de l'affaire n'ont pas de prénom : on retombe alors sur le nom seul, et sur
      // le matricule si le nom manque aussi.
      formatter: (context, value) => {
        if (!value || !value.id) return null;
        const identite = [value.firstname, value.lastname].filter(Boolean).join(" ").trim();
        if (!identite) return value.gaia_id || null;
        return value.gaia_id ? identite + " (" + value.gaia_id + ")" : identite;
      }
    },
    {
      name: 'start_date',
      label: "Date de début",
      type: 'date',
      inForm: true,
      required: true,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'imputable',
      label: "Imputable",
      type: 'yesno',
      inForm: true,
      required: true,
      inList: true,
    },
    {
      name: 'imputable',
      label: "Imputable",
      type: 'yesno',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? "Oui" : "Non"
    },
    {
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      tabFilter: true,
      key: 'status_slug',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: true,
      sortable: true,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'rentings',
      label: "Commandes",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value.length : 0
    },
    {
      name: 'business_returns',
      label: "Retours",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value.length : 0
    },
    {
      name: 'transfers',
      label: "Transferts",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value.length : 0
    },
    {
      name: 'manual_billings',
      label: "Factures manuelles",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value.length : 0
    },
    {
      name: 'internal_billing_lines',
      label: "Factures automatiques",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? [...new Set(value.map(item => item.internal_billing.id))].length : 0
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Business/config.js